/* eslint-disable react/function-component-definition */
import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormSelectProps } from './types';
import { generatePlaceholderForDropdownField } from '../utils';

// components
import { Select } from '@ui';

function FormSelect<Option = unknown>({
  validationRules,
  placeholder: propsPlaceholder,
  renderPlaceholder,
  ...rest
}: FormSelectProps<Option>) {
  const { t } = useTranslation('form');

  const placeholder = useMemo(() => {
    if (propsPlaceholder) {
      return propsPlaceholder;
    }

    if (renderPlaceholder) {
      return renderPlaceholder(validationRules || []);
    }

    const isMultiSelect = rest.mode === 'multiple';
    return generatePlaceholderForDropdownField(
      isMultiSelect,
      validationRules || [],
      t,
    );
  }, [validationRules, propsPlaceholder, renderPlaceholder]);

  return <Select {...rest} placeholder={placeholder} />;
}

export default FormSelect;
